module.exports = __webpack_public_path__ + "img/Jannis.cf870b49.jpeg";